export const USERS_GET_ALL = "USERS_GET_ALL";
export const USER_CHANGE_PASSWORD = "USER_CHANGE_PASSWORD";
export const USER_CHANGE_STATUS = "USER_CHANGE_STATUS";
export const USER_DELETE = "USER_DELETE";
export const USER_ADD_NEW = "USER_ADD_NEW";
export const USER_UPDATE = "USER_UPDATE";
export const USERS_DELETE_SELECTED = "USERS_DELETE_SELECTED"; 